import { Tab, TabList } from '@chakra-ui/react'

// Constant
import config from '@/config'
import { RoleInOffer } from '../../constants'

const OfferTabList = ({ subSystems, role, tabIndex, offerStatus, disableBooking = true, disableLegal = true }) => {
  const isProcurement = role === RoleInOffer.PROCUREMENT_OFFICER
  const offerType = subSystems[0]?.type
  return (
    <TabList zIndex={3} bg="white" position="sticky" top="146px">
      <Tab
        _hover={{ color: 'teal' }}
        isDisabled={isProcurement}
        fontWeight={'bold'}
        color={tabIndex === 0 || tabIndex > 10 ? 'teal' : 'black'}
        p={0}
      >
        Offer Overview
      </Tab>

      <Tab _hover={{ color: 'teal' }} isDisabled={isProcurement} fontWeight={'bold'}>
        Documents
      </Tab>
      <Tab _hover={{ color: 'teal' }} isDisabled={disableLegal} fontWeight={'bold'}>
        Legal
      </Tab>
      <Tab _hover={{ color: 'teal' }} isDisabled={isProcurement} fontWeight={'bold'}>
        Commercial Checklist
      </Tab>

      <Tab _hover={{ color: 'teal' }} isDisabled={isProcurement || disableBooking} fontWeight={'bold'}>
        Booking
      </Tab>

      <Tab _hover={{ color: 'teal' }} fontWeight={'bold'}>
        Sourcing
      </Tab>
      <Tab _hover={{ color: 'teal' }} isDisabled={isProcurement} fontWeight={'bold'}>
        GC Material
      </Tab>

      <Tab _hover={{ color: 'teal' }} isDisabled={disableBooking} fontWeight={'bold'}>
        GCPR
      </Tab>

      {config.PREnabled && (
        <Tab _hover={{ color: 'teal' }} isDisabled={disableBooking} fontWeight={'bold'}>
          PR
        </Tab>
      )}

      {config.handoverFormEnabled && (
        <Tab
          _hover={{ color: 'teal' }}
          isDisabled={isProcurement || disableBooking || offerType == 'maintenance'}
          fontWeight={'bold'}
        >
          Project Handover Form
        </Tab>
      )}

      <Tab _hover={{ color: 'teal' }} isDisabled={isProcurement} fontWeight={'bold'}>
        Cost Structure
      </Tab>
      <Tab _hover={{ color: 'teal' }} isDisabled={isProcurement} fontWeight={'bold'}>
        History
      </Tab>
    </TabList>
  )
}

export default OfferTabList
